import { Component, input } from '@angular/core';
import {
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexGrid,
  ApexLegend,
  ApexMarkers,
  ApexPlotOptions,
  ApexResponsive,
  ApexStroke,
  ApexTheme,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
  NgApexchartsModule,
} from 'ng-apexcharts';

export type ChartOptions = {
  series?: any;
  nonSeries?: any;
  chart?: ApexChart;
  stroke?: ApexStroke;
  labels?: any;
  dataLabels?: ApexDataLabels;
  plotOptions?: ApexPlotOptions;
  yaxis?: ApexYAxis | ApexYAxis[];
  xaxis?: ApexXAxis;
  grid?: ApexGrid;
  colors?: string[];
  tooltip?: ApexTooltip;
  title?: ApexTitleSubtitle;
  fill?: ApexFill;
  markers?: ApexMarkers;
  theme?: ApexTheme;
  responsive?: ApexResponsive[];
  legend?: ApexLegend;
  subtitle?: ApexTitleSubtitle;
};

@Component({
  selector: 'lepi-chart',
  standalone: true,
  imports: [NgApexchartsModule],
  templateUrl: './chart.component.html',
})
export class ChartComponent {
  options = input<ChartOptions>();
}
